import { inlineGET as GET } from "../../../axios";
import store from "../../../store";
import types from "./types";

export async function getProjectProfile(id) {
  const projectProf = await GET("/context/projects/" + id + "/profile");
  store.dispatch({ type: types.GET_PROJECT_PROFILE, projectProf });
}
